import { render, staticRenderFns } from "./LogoLoader.vue?vue&type=template&id=60f70774&"
import script from "./LogoLoader.vue?vue&type=script&lang=js&"
export * from "./LogoLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports